document.addEventListener(
	'DOMContentLoaded',
	() => {

        const target = document.querySelectorAll( '.js-shrink-content' );
		target.forEach(element => {
			element.addEventListener(
                'click',
                (event) => {
                    event.preventDefault();
                    element.classList.remove('js-shrink-content');   
                    element.classList.remove('is-shrink');
                }
            )
		});	

    }
)